import { put, takeLatest } from 'redux-saga/effects';
import * as c from 'constants/actionTypes/catalog';
import { GET } from '@kealabs/kea-services/util/constants';
import moment from 'moment';
import filterCatalogProducts from '../util/filterCatalogProducts';
import {
  dateFormat,
  prepareDateRange,
  wsClient,
} from '../util/appUtils';

export const normalizeProductListResponse = (response, {
  paged, start, limit,
}) => {
  const envelope = paged && response && !Array.isArray(response) && Array.isArray(response.items);
  const items = envelope ? response.items : (Array.isArray(response) ? response : []);
  const provisionalTotal = Number(start || 0) + items.length
    + (paged && Number(limit) > 0 && items.length === Number(limit) ? 1 : 0);
  return {
    items,
    total: envelope ? Number(response.total || 0) : provisionalTotal,
  };
};

function* getProductById(action) {
  try {
    const { range, shopId, productId } = action.payload;
    const { from, to } = prepareDateRange(range);

    const qs = { shopId, productId, from, to };
    const path = 'system/catalog/product';
    const response = yield wsClient.prepareRequest(GET, path, { qs });
    let { data, trendingCurve, stats } = response;

    trendingCurve = trendingCurve.map((el) => {
      const { year, month, day } = el._id;
      const date = moment([year, month - 1, day]).format(dateFormat);
      return { label: date, count: el.count };
    });

    yield put({
      type: c.GET_PRODUCT_BY_ID_COMPLETE,
      payload: { data, trendingCurve, stats },
    });
  } catch (err) {
    yield put({ type: c.GET_PRODUCT_BY_ID_FAILED, payload: err });
  }
}

function* getProducts(action) {
  try {
    const path = 'system/catalog/products';
    const {
      shopId, start, limit, query, paged,
    } = action.payload;
    const response = yield wsClient.prepareRequest(GET, path, {
      qs: {
        shopId,
        skip: start,
        limit,
        ...(query ? { query } : {}),
        ...(paged ? { paged: true } : {}),
      },
    });
    const normalized = normalizeProductListResponse(response, { paged, start, limit });
    const data = normalized.items;

    const products = data.map((product) => ({
      id: product.id,
      product: `${product.vendor ? `${product.vendor} - ` : ''} ${product.name}`,
      vendor: product.vendor,
      vendorCode: product.vendorCode,
      name: product.name,
      thumbnail: product.thumbnail,
    }));

    yield put({
      type: c.GET_PRODUCTS_COMPLETE,
      payload: {
        data: products,
        total: normalized.total,
        shopId,
        start,
        limit,
        query,
      },
    });
  } catch (err) {
    yield put({ type: c.GET_PRODUCTS_FAILED, payload: err.message });
  }
}

function* filterProducts(action) {
  const { query, data } = action.payload;
  const filtered = filterCatalogProducts(query, data);

  yield put({ type: c.FILTER_PRODUCTS_BY_QUERY_COMPLETE, payload: { data: filtered } });
}

export default function* catalogSagas() {
  yield takeLatest(c.GET_PRODUCT_BY_ID, getProductById);
  yield takeLatest(c.GET_PRODUCTS, getProducts);
  yield takeLatest(c.FILTER_PRODUCTS_BY_QUERY, filterProducts);
}
